import { Component } from '@angular/core';
import { BaseAdvancedPropertyViewComponent } from '../base-advanced-property-view.component';
import { MultiPurposeAreaComponent } from 'src/app/models/components/objectComponents/MultiPurposeAreaComponent';
import { ComponentNames } from 'src/app/helper/componentNames';
import { getComponentFromSource } from 'src/app/generics-helper/getComponentFromSource.generic';
import { PersonsPerSquareMeterComponent } from 'src/app/models/components/commonComponents/PersonsPerSquareMeterComponent';
import { userHasFeature } from 'src/app/helper/userHasFeature';
import { FeatureEnum } from 'src/app/models/enums/FeatureEnum';
import { AuthService } from 'src/app/services/auth.service';
import { MatDialogRef } from '@angular/material/dialog';
import { InputHelper } from 'src/app/helper/inputHelper';

@Component({
  selector: 'app-multipurposearea',
  templateUrl: './multipurposearea.component.html',
  styleUrls: ['./multipurposearea.component.scss']
})
export class MultiPurposeAreaViewComponent extends BaseAdvancedPropertyViewComponent {

  multiPurposeAreaComponent: MultiPurposeAreaComponent = new MultiPurposeAreaComponent();
  personsPerSquareMeterComponent: PersonsPerSquareMeterComponent = new PersonsPerSquareMeterComponent();
  show: boolean = false;
  showFeatureBycicleAmount: boolean;
  showFeatureSkiAmount: boolean;
  showFeatureStrollerAmount: boolean;
  integerOnly = InputHelper.integerOnly;

  constructor(private authService: AuthService, public dialogRef: MatDialogRef<BaseAdvancedPropertyViewComponent>) {
    super(dialogRef);
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.multiPurposeAreaComponent = getComponentFromSource(ComponentNames.multiPurposeAreaComponent, this.items);
    this.personsPerSquareMeterComponent = getComponentFromSource(ComponentNames.personsPerSquareMeterComponent, this.items);
    this.loadFeatures();
  }

  saveButtonDisabledState(): boolean {
    return false;
  }

  loadFeatures() {
    this.showFeatureBycicleAmount = userHasFeature(this.authService.getCurrentFeatures(), FeatureEnum.CanOverrideBycicleAmountMultiPurposeArea);
    this.showFeatureSkiAmount = userHasFeature(this.authService.getCurrentFeatures(), FeatureEnum.CanOverrideSkiAmountMultiPurposeArea);
    this.showFeatureStrollerAmount = userHasFeature(this.authService.getCurrentFeatures(), FeatureEnum.CanOverrideStrollerAmountMultiPurposeArea);
  }
}
